import { ComponentPropsWithoutRef } from 'react';
import { EmptyBoxImage } from '@tymbe/ty-components/illustrations';
import { H4, Paragraph } from '@tymbe/ty-components/text';

interface TyCalEmptyProps extends ComponentPropsWithoutRef<'div'> {
  show: boolean;
  title?: string,
  text?: string,
}

const TyCalEmpty = ({
  show,
  title = 'Je to prázdné!',
  text = 'Jestli se zde něco nacházelo, tak je to pryč.',
  ...rest
}: TyCalEmptyProps) => {
    if (!show) return null;

  return (
    <div {...rest}>
      <EmptyBoxImage />
        <H4 className="text-secondary-500">{title}</H4>
        <Paragraph variant="body2Rg" className="text-secondary-400">
          {text}
        </Paragraph>
    </div>
  );
};

export default TyCalEmpty;
